const oaApprove = {
  namespaced: true,
  state: {
    nodeMap: new Map(),
    isEdit: null,
    selectedNode: {
      props: {
        assignedType: ''
      }
    },
    selectFormItem: null,
    design: {
      groupId: -1,
      category: 'custom'
    },
    runningList: [],
    noTakeList: [],
    endList: [],
    currentNode: {},
    logo: {},
    diagramMode: 'design'
  },
  mutations: {
    selectedNode (state, val) {
      state.selectedNode = val
    },
    loadForm (state, val) {
      state.design = val
    },
    setIsEdit (state, val) {
      state.isEdit = val
    },
    setDesignFormName (state, val) {
      state.design.formName = val
    },
    setDesignCategory (state, val) {
      state.design.category = val
    },
    setDesignGroupId (state, val) {
      state.design.groupId = val
    },
    setDesignRemark (state, val) {
      state.design.remark = val
    },
    setDiagramMode (state, val) {
      state.diagramMode = val
    },
    setSelectedNodePropsAssignedType (state, val) {
      if (state.selectedNode !== undefined && state.selectedNode.props !== undefined) {
        state.selectedNode.props.assignedType = val
      }
    }
  },
  getters: {},
  actions: {},
  modules: {}
}

export default oaApprove
